import {
  DEFAULT_COMPARE_DURATION_A_NAME,
  DEFAULT_COMPARE_DURATION_B_NAME,
  DEFAULT_COMPARE_FILTER_A_NAME,
  DEFAULT_COMPARE_FILTER_B_NAME,
} from '@modules/quantify/constants';
import { useGetMeasuredAsDisplayName } from '@modules/quantify/hooks';
import { useGetCompareColors } from '@modules/quantify/hooks/useGetCompareColors';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { CircleRounded } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

export const CompareBarChartXAxisLabel = () => {
  const { colorA, colorB } = useGetCompareColors();
  const compareTo = useQuantifyStore(({ query }) => query.compareQuery);
  const formulaID = useQuantifyStore(
    ({ query }) => query.formulaQuery?.eqlFunction,
  );

  const compareFilterAName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.baseQueryName || DEFAULT_COMPARE_FILTER_A_NAME,
  );
  const compareFilterBName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.deltaQueryName || DEFAULT_COMPARE_FILTER_B_NAME,
  );
  const compareDurationAName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.baseQueryName || DEFAULT_COMPARE_DURATION_A_NAME,
  );
  const compareDurationBName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.deltaQueryName || DEFAULT_COMPARE_DURATION_B_NAME,
  );

  const measuredAsDisplayName = useGetMeasuredAsDisplayName({ formulaID });

  const compareByLabelA = compareTo?.whereClause
    ? compareFilterAName
    : compareDurationAName;
  const compareByLabelB = compareTo?.whereClause
    ? compareFilterBName
    : compareDurationBName;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      spacing={3}
    >
      <Typography variant="caption" color="text.primary">
        {measuredAsDisplayName}
      </Typography>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Stack direction="row" alignItems="center" spacing={0.6}>
          <CircleRounded sx={{ color: colorA, width: 12 }} />
          <Typography variant="caption">{compareByLabelA}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <CircleRounded sx={{ color: colorB, width: 12 }} />
          <Typography variant="caption">{compareByLabelB}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
